import { createSelector } from '@ngrx/store';
import { StoryblokGlobalContentState } from './storyblok-global-content.state';
import { getStoryblokState } from '../feature-selector';
import { StoryblokState } from '../state';

export const getStoryblokGlobalContentState = createSelector(getStoryblokState, (state: StoryblokState) => {
  return state.storyblokGlobalContent;
});

export const isStoryblokGlobalContentLoaded = createSelector(
  getStoryblokGlobalContentState,
  (storyblokGlobalContentState: StoryblokGlobalContentState) => {
    return storyblokGlobalContentState.isLoaded;
  }
);

export const getPromoWidgetLink = createSelector(
  getStoryblokGlobalContentState,
  (storyblokGlobalContentState: StoryblokGlobalContentState) => {
    return storyblokGlobalContentState.promoWidgetLink;
  }
);

export const getNavigation = createSelector(
  getStoryblokGlobalContentState,
  (storyblokGlobalContentState: StoryblokGlobalContentState) => {
    return storyblokGlobalContentState.navigation;
  }
);

export const getOfferMenuContent = createSelector(
  getStoryblokGlobalContentState,
  (storyblokGlobalContentState: StoryblokGlobalContentState) => {
    return storyblokGlobalContentState.offerMenuContent;
  }
);
